import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [푸시 알림] 신규로 발생한 이벤트 이력 목록 조회
   * @author jeee12
   * @return {[type]} [description]
   */
  getPushNotificationEventInfo(params) {
    return axios.post(`${baseUrl}/frame/push-notification/get-event-info.do`, params);
  },
  /**
   * [푸시 알림] 신규로 발생한 사전 예측 이벤트 이력 목록 조회
   * @author jeee12
   * @return {[type]} [description]
   */
  getPushNotificationPredictEventInfo(params) {
    return axios.post(`${baseUrl}/frame/push-notification/get-predict-event-info.do`, params);
  },
  /**
   * [푸시 알림 설정] 로그인한 계정 기준 푸시 알림 수신여부 설정 조회
   * @author jeee12
   * @return {[type]} [description]
   */
  getPushNotificationReceiveFlagSettingData() {
    return axios.get(`${baseUrl}/frame/push-notification/get-receive-flag-setting-data.do`);
  },
  /**
   * [푸시 알림 설정] 로그인한 계정 기준 푸시 알림 수신여부 설정 수정
   * @author jeee12
   * @return {[type]} [description]
   */
  updatePushNotificationReceiveFlagSetting(params) {
    return axios.post(`${baseUrl}/frame/push-notification/update-push-notification-receive-flag-setting.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/frame/push-notification.js